import PaymentsContent from "../../../components/Admin/Payments";

const AdminPayments = () => {
  return (
    <>
      <PaymentsContent />
    </>
  );
};

export default AdminPayments;
